<template>
  <skud-dashboard />
</template>

<script>
import SkudDashboard from '@/views/skud/components/SkudDashboard.vue'

export default {
  name: 'SkudDashboardPage',
  components: { SkudDashboard }
}
</script>
